"use strict";

import angular from "angular";
/**
 * @component NuHeaderData
 * O <nu-header-data> - is a component used for show a header contain Nanda button(optional), title and legend
 */

import template from "./header-data.component.html";
import "./header-data.component.scss";

const name = "nuHeaderData";
const def = {
    bindings: {
        showNanda: "=",
        label: "=",
        subtitle: "="
    },
    controllerAs: "headerDataCtrl",
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
